import Component from '../Component';
import Button from './Button';
import listItems from '../helpers/listItems';
import extract from '../utils/extract';
import classList from '../utils/classList';
import app from '../app';
import Icon from './Icon';
/**
 * The `Alert` component represents an alert box, which contains a message,
 * some controls, and may be dismissible.
 */
export default class Alert extends Component {
  view(vnode) {
    const attrs = Object.assign({}, this.attrs);
    const type = extract(attrs, 'type');
    attrs.className = classList('Alert', "Alert--".concat(type), attrs.className);
    const title = extract(attrs, 'title');
    const icon = extract(attrs, 'icon');
    const content = extract(attrs, 'content') || vnode.children;
    const controls = extract(attrs, 'controls') || [];

    // If the alert is meant to be dismissible (which is the case by default),
    // then we will create a dismiss button to append as the final control in
    // the alert.
    const dismissible = extract(attrs, 'dismissible');
    const ondismiss = extract(attrs, 'ondismiss');
    const dismissControl = [];
    if (dismissible || dismissible === undefined) {
      dismissControl.push(m(Button, {
        "aria-label": app.translator.trans('core.lib.alert.dismiss_a11y_label'),
        icon: "fas fa-times",
        className: "Button Button--link Button--icon Alert-dismiss",
        onclick: ondismiss
      }));
    }
    return m("div", attrs, m("div", {
      className: classList('Alert-container', attrs.containerClassName)
    }, m("div", {
      className: "Alert-content"
    }, !!title && m("div", {
      className: "Alert-title"
    }, !!icon && m("span", {
      className: "Alert-title-icon"
    }, m(Icon, {
      name: icon
    })), m("span", {
      className: "Alert-title-text"
    }, title)), m("span", {
      className: "Alert-body"
    }, content)), m("ul", {
      className: "Alert-controls"
    }, listItems(controls.concat(dismissControl)))));
  }
}
flarum.reg.add('core', 'common/components/Alert', Alert);